import { App } from './app.class';
import { Modal } from './modal.class';
import { Notification } from './notification.class';
import { Fetch } from '../fetch.class';
import * as Sqrl from 'squirrelly';
import { Popup } from './popup.class';

export class Page {

    constructor() {

        // Template für App-Zugänge
        this.tplAppAccesses = Sqrl.compile( document.getElementById('tpl_app_accesses').innerHTML.replace(/=&gt;/g, '=>') );

        // Elemente
        this.$contentAccesses = document.querySelector('#content_app_accesses');

        // Zugänge laden
        this.loadAppAccesses();


        // --- Neuer App-Zugang

        // Modal: Zugang anlegen
        this.$modalAddAccess = document.querySelector('#modal-add-access');
        this.modalAddAccess = new Modal('#modal-add-access');
        this.$formAddAccess = this.$modalAddAccess.querySelector('form');
        this.$errorboxAddAccess = this.$modalAddAccess.querySelector('.errorbox');

        // Formular-Option in Modal
        this.$formRadiosAddAccess = this.$modalAddAccess.querySelectorAll('input[name=form_access_type]');
        this.$formRadiosAddAccess.forEach(($radio) => {
            $radio.addEventListener('change', event => {
                this.refreshFormMarkup(this.$formAddAccess);
            });
        });

        // Speicherung
        this.$formAddAccess.addEventListener('submit', event => {

            event.preventDefault();

            // Sendedaten
            const data = new FormData();
            var typeValue = this.$formAddAccess.querySelector('input[name="form_access_type"]:checked').value;
            var access_forms_str = "";
            if(typeValue === "selection") {
                var checkbxs = this.$modalAddAccess.querySelectorAll('input[name=form_selected]:checked');
                checkbxs.forEach(($bx) => {
                    access_forms_str += $bx.value+",";
                });
                if(access_forms_str.length > 0) {
                    access_forms_str = access_forms_str.substring(0,access_forms_str.length-1);
                }
            }
            else if(typeValue === "all") {
                access_forms_str = "all";
            }
            data.append("access_forms", access_forms_str);

            // Fehler ausblenden
            this.$errorboxAddAccess.classList.add('hidden');

            // Senden
            new Fetch().post(App.getUrl('app', 'add_access'), data)
            .then(response => {

                // Modal schliessen
                this.modalAddAccess.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // Neuladen der Zugangsliste
                this.loadAppAccesses();
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxAddAccess.querySelector('.cont').textContent = error.message;
                this.$errorboxAddAccess.classList.remove('hidden');
            });
        });


        // --- Formularfreigaben bearbeiten

        // Modal
        this.$modalEditForms = document.querySelector('#modal-edit-forms');
        this.modalEditForms = new Modal('#modal-edit-forms');
        this.$formEditForms = this.$modalEditForms.querySelector('form');
        this.$errorboxEditForms = this.$modalEditForms.querySelector('.errorbox');

        // Formular-Option in Modal
        this.$formRadiosEditForms = this.$modalEditForms.querySelectorAll('input[name=form_access_type]');
        this.$formRadiosEditForms.forEach(($radio) => {
            $radio.addEventListener('change', event => {
                this.refreshFormMarkup(this.$formEditForms);
            });
        });

        // Speicherung
        this.$formEditForms.addEventListener('submit', event => {

            event.preventDefault();

            // Sendedaten
            const data = new FormData();
            data.append("access_id", this.$formEditForms.querySelector('input[name="access_id"]').value);
            var typeValue = this.$formEditForms.querySelector('input[name="form_access_type"]:checked').value;
            var access_forms_str = "";
            if(typeValue === "selection") {
                var checkbxs = this.$modalEditForms.querySelectorAll('input[name=form_selected]:checked');
                checkbxs.forEach(($bx) => {
                    access_forms_str += $bx.value+",";
                });
                if(access_forms_str.length > 0) {
                    access_forms_str = access_forms_str.substring(0,access_forms_str.length-1);
                }
            }
            else if(typeValue === "all") {
                access_forms_str = "all";
            }
            data.append("access_forms", access_forms_str);

            // Fehler ausblenden
            this.$errorboxEditForms.classList.add('hidden');

            // Senden
            new Fetch().post(App.getUrl('app', 'save_access_forms'), data)
            .then(response => {

                // Modal schliessen
                this.modalEditForms.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // Neuladen der Zugangsliste
                this.loadAppAccesses();
            })
            .catch(error => {

                // Fehlermeldung anzeigen
                this.$errorboxEditForms.querySelector('.cont').textContent = error.message;
                this.$errorboxEditForms.classList.remove('hidden');
            });
        });


        // --- Zugang löschen

        // Modal
        this.$modalDeleteAccess = document.querySelector('#modal-delete-access');
        this.modalDeleteAccess = new Modal('#modal-delete-access');

        // Löschung ausführen
        const $btnModalDeleteAccess = this.$modalDeleteAccess.querySelector('button.delete');
        $btnModalDeleteAccess.addEventListener('click', event => {

            // Sendedaten
            const data = new FormData();
            data.append("access_id", this.$modalDeleteAccess.dataset.id);

            // Senden
            new Fetch().post(App.getUrl('app', 'delete_access'), data)
            .then(response => {

                // Modal schliessen
                this.modalDeleteAccess.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // Neuladen der Zugangsliste
                this.loadAppAccesses();
            })
            .catch(error => {

                // Modal schliessen
                this.modalDeleteAccess.close();

                // Fehlermeldung anzeigen
                new Notification().error(error.message);
            });

        });

        // --- Verbindung löschen

        // Modal
        this.$modalDeleteConnection = document.querySelector('#modal-delete-connection');
        this.modalDeleteConnection = new Modal('#modal-delete-connection');

        // Löschung ausführen
        const $btnModalDeleteConnection = this.$modalDeleteConnection.querySelector('button.delete');
        $btnModalDeleteConnection.addEventListener('click', event => {

            // Sendedaten
            const data = new FormData();
            data.append("connection_id", this.$modalDeleteConnection.dataset.id);

            // Senden
            new Fetch().post(App.getUrl('app', 'delete_connection'), data)
            .then(response => {

                // Modal schliessen
                this.modalDeleteConnection.close();

                // Erfolgsmeldung
                new Notification().success(response.msg);

                // Neuladen der Zugangsliste
                this.loadAppAccesses();
            })
            .catch(error => {

                // Modal schliessen
                this.modalDeleteConnection.close();

                // Fehlermeldung anzeigen
                new Notification().error(error.message);
            });

        });
    }

    // App-Zugänge laden
    loadAppAccesses() {

        // Daten abrufen
        new Fetch().get(App.getUrl('app', 'load_accesses_data'))
        .then(response => {

            // Inhalt aus Template erstellen
            this.$contentAccesses.innerHTML = this.tplAppAccesses(response, Sqrl.defaultConfig);

            // Events ---

            // PopUps initialisieren
            const popups = this.$contentAccesses.querySelectorAll(".popup");
            popups.forEach($ele => {
                const p = new Popup($ele, instance => {
                    window.Popups.forEach(p => {
                        if(p !== instance) {
                            p.close();
                        }
                    });
                });
                window.Popups.push(p);
            });

            // Klick auf Anlegen-Buttons
            const $btnsAddAccess = this.$contentAccesses.querySelectorAll('button.add-access');
            $btnsAddAccess.forEach(($btn) => {
                $btn.addEventListener('click', event => {

                    // Fehlermeldung ausblenden
                    this.$errorboxAddAccess.classList.add('hidden');

                    // Modal öffnen
                    this.modalAddAccess.show();
                });
            });

            // Aktion: Formularfreigaben
            const $btnsActionForms = this.$contentAccesses.querySelectorAll('button.action.forms');
            $btnsActionForms.forEach(($btn) => {
                $btn.addEventListener('click', event => {
                    const $accessLi = event.currentTarget.closest('li');
                    const accessId = $accessLi.dataset.id;
                    this.openEditAccessForms(accessId);
                });
            });

            // Aktion: Zugang löschen
            const $btnsActionDeleteAccess = this.$contentAccesses.querySelectorAll('button.action.delete');
            $btnsActionDeleteAccess.forEach(($btn) => {
                $btn.addEventListener('click', event => {

                    // Access-ID in Modal übernehmen
                    const $accessLi = event.currentTarget.closest('li');
                    this.$modalDeleteAccess.dataset.id = $accessLi.dataset.id;

                    // Modal öffnen
                    this.modalDeleteAccess.show();
                });
            });

            // Aktion: Verbindung löschen
            const $btnsActionDeleteConnection = this.$contentAccesses.querySelectorAll('.devicelist button.remove');
            $btnsActionDeleteConnection.forEach(($btn) => {
                $btn.addEventListener('click', event => {

                    // Connection-ID in Modal übernehmen
                    const $connectionLi = event.currentTarget.closest('li');
                    this.$modalDeleteConnection.dataset.id = $connectionLi.dataset.id;

                    // Modal öffnen
                    this.modalDeleteConnection.show();
                });
            });
        })
        .catch(error => {

            // Fehlermeldung anzeigen
            new Notification().error(error.message);
        })
        .finally(() => {

        });
    }

    // Modal mit Formularfreigaben öffnen
    openEditAccessForms(access_id) {

        // Forms-Value
        const $li = this.$contentAccesses.querySelector('ul.accesses > li[data-id="'+access_id+'"]');
        const forms = $li.dataset.forms;

        // Formular vorbelegen
        const $inputAccessId = this.$modalEditForms.querySelector('input[name=access_id]');
        $inputAccessId.value = access_id;
        const $radioAll = this.$modalEditForms.querySelector('input[name=form_access_type][value="all"]');
        const $radioSelection = this.$modalEditForms.querySelector('input[name=form_access_type][value="selection"]');
        if(forms == "all") {
            $radioAll.checked = true;
            $radioSelection.checked = false;
        }
        else {
            $radioAll.checked = false;
            $radioSelection.checked = true;

            const parts = forms.split(',');

            const $selForms = this.$modalEditForms.querySelectorAll('input[name="form_selected"]');
            $selForms.forEach(($radio) => {
                $radio.checked = parts.includes($radio.value);
            });
        }
        this.refreshFormMarkup(this.$formEditForms)

        // Fehler ausblenden
        const $errorboxEditForms = this.$modalEditForms.querySelector('.errorbox');
        $errorboxEditForms.classList.add('hidden');

        // Modal öffnen
        this.modalEditForms.show();
    }

    // HTML-Markup in Formular entsprechend Formularfreigabe aktualisieren
    refreshFormMarkup($form) {

        var val = $form.querySelector('input[name=form_access_type]:checked').value;

        const $formSelection = $form.querySelector('.form-selection');
        const $formCheckboxes = $form.querySelectorAll('.form-selection input[type=checkbox]');
        const $formtypeAll = $form.querySelector('.form-type.all');
        const $formtypeSelection = $form.querySelector('.form-type.selection');

        if(val === "selection") {
            $formSelection.classList.remove("disabled");
            $formCheckboxes.forEach(($checkbox) => {
                $checkbox.removeAttribute("disabled");
            });
            $formtypeAll.classList.remove("active");
            $formtypeSelection.classList.add("active");
        }
        else {
            $formSelection.classList.add("disabled");
            $formCheckboxes.forEach(($checkbox) => {
                $checkbox.setAttribute("disabled", "disabled");
                $checkbox.checked = false;
            });
            $formtypeAll.classList.add("active");
            $formtypeSelection.classList.remove("active");
        }
    }
}

// Initialisierung wenn DOM geladen
App.domready(()=>{
    if(document.querySelector('body').classList.contains('app')) {
        new Page();
    }
});